var waitFor = require("../utils/waitFor");

waitFor(".js-language-select", function () {
  $(".js-language-select").on("click", function (e) {
    var $el = $(e.currentTarget);

    if ($el.hasClass("is-open")) {
      $el.addClass("is-hiding").removeClass("is-open");
      setTimeout(function () {
        $el.removeClass("is-hiding");
      }, 1000);
    } else {
      $el.addClass("is-open");
    }

    e.preventDefault();
  });
});
